import { render, staticRenderFns } from "./addShopRecommend.vue?vue&type=template&id=d277de3e&scoped=true"
import script from "./addShopRecommend.vue?vue&type=script&lang=js"
export * from "./addShopRecommend.vue?vue&type=script&lang=js"
import style0 from "./addShopRecommend.vue?vue&type=style&index=0&id=d277de3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d277de3e",
  null
  
)

export default component.exports